module.exports = __webpack_public_path__ + "img/list.be57649f.svg";